export default __webpack_public_path__ + "static/media/bwin.62fd3bdc.png";